import axios from '@fs/zion-axios'

const BASE_TEMPLE_INVENTORY_PATH = '/service/dmc/temple-inventory'

export async function getTempleInventoryProfiles(templeCode) {
  if (!templeCode) {
    return null
  }

  const url = `${BASE_TEMPLE_INVENTORY_PATH}/inventory-profiles/${templeCode}/profiles`

  return axios.get(url).then((response) => {
    return response.data
  })
}

export async function createTempleInventoryProfile(templeProfile) {
  if (!templeProfile) {
    return null
  }

  const url = `${BASE_TEMPLE_INVENTORY_PATH}/inventory-profiles`

  return axios.post(url, templeProfile).then((response) => {
    return response.data
  })
}

export async function updateTempleInventoryProfile(templeCode, lang, templeProfile) {
  if (!templeCode || !lang || !templeProfile) {
    return null
  }

  const url = `${BASE_TEMPLE_INVENTORY_PATH}/inventory-profiles/${templeCode}/profiles/${lang}`

  return axios.put(url, templeProfile).then((response) => {
    return response.data
  })
}

export async function deleteTempleInventoryProfile(templeCode, lang) {
  if (!templeCode || !lang) {
    return null
  }

  const url = `${BASE_TEMPLE_INVENTORY_PATH}/inventory-profiles/${templeCode}/profiles/${lang}`

  return axios.delete(url).then((response) => {
    return response.data
  })
}

export async function getTempleInventoryItem(osId) {
  if (!osId) {
    return null
  }

  const url = `${BASE_TEMPLE_INVENTORY_PATH}/item/${osId}`

  return axios.get(url).then((response) => {
    return response.data
  })
}
